import axios, { all } from 'axios';
import React, { useEffect, useState } from 'react';
import { formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { useOutletContext } from 'react-router-dom';
import { FaFolderOpen } from 'react-icons/fa';
import Select from 'react-select';

export default function Pivot({ startDate, endDate }) {
  const [cashData, setCashData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedCOA, setSelectedCOA] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCollectionCenter, setSelectedCollectionCenter] = useState(null);
  const [selectedPayee, setSelectedPayee] = useState(null);
  const [descriptionSearch, setDescriptionSearch] = useState('');

  const auth = useAuth();
  const { allData } = useOutletContext();

  var codeNames = [
    { id: "151", name: "LOCAL TAXES" },
    { id: "152", name: "FEES AND CHARGES" },
    { id: "153", name: "LICENCES" },
    { id: "154", name: "LEVIES" },
    { id: "155", name: "PERMITS" },
    { id: "156", name: "CHARGES" },
    { id: "157", name: "OTHER INCOMES" },
    { id: "158", name: "NATIONAL SUPPORT (GRANTS)" },
    { id: "159", name: "DONOR SUPPORT" },
    { id: "111", name: "Total" },
    { id: "211", name: "Salaries" },
    { id: "212", name: "Wages" },
    { id: "213", name: "Allowances" },
    { id: "214", name: "Emolument Expenses" },
    { id: "221", name: "Office Costs" },
    { id: "222", name: "Building, Repair and Maintenance Costs" },
    { id: "223", name: "Plant, Machinery, Vehicle Running and Maintenance Costs" },
    { id: "224", name: "Other Administrative Operating Costs" },
    { id: "225", name: "Requisites" },
    { id: "226", name: "Services" },
    { id: "227", name: "Travel Expenses" },
    { id: "228", name: "Training" },
    { id: "229", name: "Legal Costs" },
    { id: "231", name: "Depreciation on Own Assets" },
    { id: "232", name: "Depreciation on Leased Property (Finance Lease)" },
    { id: "241", name: "Interest on Domestic Debt" },
    { id: "242", name: "Interest on External Debt" },
    { id: "243", name: "Financial Charges" },
    { id: "244", name: "Settlement of Outstanding Bills - Financial Charges" },
    { id: "249", name: "Other Financial Charges" },
    { id: "251", name: "Social Assistance Benefits" },
    { id: "261", name: "Grants to Grant-aided Institutions" },
    { id: "262", name: "Grants to Non-Governmental Organisations" },
    { id: "263", name: "Grants to Households" },
    { id: "264", name: "Grants to Institutional Revolving Funds" },
    { id: "265", name: "Other Grants" },
    { id: "267", name: "Other Payments" },
    { id: "271", name: "Subsidies to Non-Financial Enterprises" },
    { id: "272", name: "Subsidies to Financial Institutions" },
    { id: "273", name: "Subsidies to Private Enterprises" },
    { id: "274", name: "Other Subsidies" },
    { id: "281", name: "Legal Expenses" },
    { id: "291", name: "Constitutional Expenditure" },
    { id: "292", name: "Other Constitutional Expenditure" },
    { id: "293", name: "Allowances" },
    { id: "294", name: "Statutory Expenditure" },
    { id: "295", name: "Other Expenses" },
    { id: "311", name: "Fixed Assets" },
    { id: "312", name: "Stocks (Inventories)" },
    { id: "313", name: "Valuables" },
    { id: "314", name: "Non-Produced Assets" },
    { id: "320", name: "Long Term Investments" },
    { id: "321", name: "Debtors" },
    { id: "322", name: "Staff Debtors" },
    { id: "323", name: "Prepayments" },
    { id: "324", name: "VAT refunds" },
    { id: "325", name: "Foreign Debtors" },
    { id: "326", name: "Cash and Cash Equivalents" },
    { id: "411", name: "Creditors" },
    { id: "421", name: "Creditors" },
    { id: "520", name: "Current Year Surplus/(Deficit)" },
    { id: "530", name: "Reserves" },
    { id: "611", name: "Realised Gains/Losses" },
    { id: "621", name: "Unrealised Gains/Losses" },
    { id: "631", name: "Miscellaneous" },
    { id: "510", name: "Owners Fund" },
    { id: "000", name: "Rest" },]
  useEffect(() => {
    if (endDate === "" || startDate === "") return;

    axios
      .get(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`))
      .then((response) => {
        const cash = response.data.data;
        setCashData(cash?.cash);
        console.log(cash?.cash)
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data', error);
        setLoading(false);
      });
  }, [endDate]);

 

  const filteredData = cashData.filter((item) => {
    const coa = allData?.budget?.find((a) => a.id === item.coa_id);
    return (
      (!selectedCode || coa?.coa?.substring(0, 3) === selectedCode.value) &&
      (!selectedCOA || coa?.coa === selectedCOA.value) &&
      (!selectedBank || item.bank === selectedBank.value) &&
      (!selectedProgram || coa?.program === selectedProgram.value) &&
      (!selectedDepartment || coa?.department === selectedDepartment.value) &&
      (!selectedCollectionCenter || item.cc_id === selectedCollectionCenter.value) &&
      (!selectedPayee || item.paye === selectedPayee.value) &&
      (!descriptionSearch || (item.description && item.description.toLowerCase().includes(descriptionSearch.toLowerCase())))
    );
  });

  const uniqueCodes = [...new Set(allData?.budget?.map(b => b.coa.substring(0, 3)))];

  // Sort filteredData by code (first 3 digits of COA) and then by COA
  const sortedData = [...filteredData].sort((a, b) => {
    const coaA = allData?.budget?.find((x) => x.id === a.coa_id)?.coa || '';
    const coaB = allData?.budget?.find((x) => x.id === b.coa_id)?.coa || '';
    const codeA = coaA.substring(0, 3);
    const codeB = coaB.substring(0, 3);
    if (codeA !== codeB) return codeA.localeCompare(codeB, undefined, { numeric: true });
    return coaA.localeCompare(coaB, undefined, { numeric: true });
  });


  console.log(allData)

  // Group by code and COA for subtotals
  const groupedRows = [];
  let currentCode = null;
  let currentCOA = null;
  let coaRows = [];
  let codeRows = [];
  let coaDebit = 0, coaCredit = 0;
  let codeDebit = 0, codeCredit = 0;

  const pushCOASubtotal = (coa, code) => {
    if (coaRows.length > 0) {
      groupedRows.push(
        <tr key={`subtotal-coa-${coa}`} className="bg-gray-100 font-bold">
          <td colSpan={14}>Subtotal for COA {coa}</td>
          <td>{formatToZMW(coaDebit)}</td>
          <td>{formatToZMW(coaCredit)}</td>
        </tr>
      );
      coaRows = [];
      coaDebit = 0;
      coaCredit = 0;
    }
  };
  const pushCodeSubtotal = (code) => {
    if (codeRows.length > 0) {
      groupedRows.push(
        <tr key={`subtotal-code-${code}`} className="bg-blue-100 font-bold">
          <td colSpan={14}>Subtotal for Code {code}</td>
          <td>{formatToZMW(codeDebit)}</td>
          <td>{formatToZMW(codeCredit)}</td>
        </tr>
      );
      codeRows = [];
      codeDebit = 0;
      codeCredit = 0;
    }
  };

  sortedData.forEach((item, index) => {
    const coaObj = allData?.budget?.find((x) => x.id === item.coa_id);
    const coa = coaObj?.coa || item.coa || '';
    if (!coa) return; // Skip rows with undefined or blank COA
    const code = coa.substring(0, 3);
    const program = coaObj?.program || item.program;
    const subprogram = coaObj?.subprogram || item.subprogram;
    const debit = item.type === 'income' ? Number(item.amount) : 0;
    const credit = item.type === 'expense' ? Number(item.amount) : 0;

    // If new code group, push previous code subtotal
    if (currentCode !== null && code !== currentCode) {
      pushCOASubtotal(currentCOA, currentCode);
      pushCodeSubtotal(currentCode);
      currentCOA = null;
    }
    // If new COA group, push previous COA subtotal
    if (currentCOA !== null && coa !== currentCOA) {
      pushCOASubtotal(currentCOA, currentCode);
    }

    groupedRows.push(
      <tr key={index} className="border-t hover:bg-gray-100">
        <td className="px-4 py-2">{code}</td>
        <td className="px-4 py-2">{codeNames.find(a=>a.id == code)?.name || item.codeName || ''}</td>
        <td className="px-4 py-2">{coa}</td>
        <td className="px-4 py-2">{allData.coa.find(a=>a.account == coa)?.name || item.coaName || ''}</td>
        <td className="px-4 py-2">{allData.program?.find(p => p.programCode === program)?.name || item.programName || ''}</td>
        <td className="px-4 py-2">{allData.subProgram?.find(s => s.subProgramCode == subprogram && s.programCode == program)?.name || item.subProgramName || ''}</td>
        <td title={item.description} className="px-4 py-2">{item.description}</td>
        <td className="px-4 py-2">{allData?.suppliers?.find((s) => s.id == item.paye)?.name || item.payeeName || ''}</td>
        <td className="px-4 py-2">{allData?.cc?.find((s) => s.id == item.cc_id)?.collection_name || 'Civic Center' || ''}</td>
        <td className="px-4 py-2">{item.cheque}</td>
        <td className="px-4 py-2">{item.date?.substring(0, 10)}</td>
        <td className="px-4 py-2">{allData.sof?.find(sof => sof.id === item.sof)?.name || item.sofName || ''}</td>
        <td className="px-4 py-2">{item.voucher}</td>
        <td className="px-4 py-2">{allData.bank?.find(b => b.id === item.bank)?.name || item.bankName || ''}</td>
        <td className="px-4 py-2">{debit ? formatToZMW(debit) : 0}</td>
        <td className="px-4 py-2">{credit ? formatToZMW(credit) : 0}</td>
      </tr>
    );
    coaRows.push(item);
    codeRows.push(item);
    coaDebit += debit;
    coaCredit += credit;
    codeDebit += debit;
    codeCredit += credit;
    currentCOA = coa;
    currentCode = code;
  });
  // Push last group subtotals
  pushCOASubtotal(currentCOA, currentCode);
  pushCodeSubtotal(currentCode);

  return (
    <div>
      <span className="text-xl font-bold mb-4 block">Pivot</span>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Select
          placeholder="Filter by Code"
          options={uniqueCodes.map(code => ({ value: code, label: code }))}
          value={selectedCode}
          onChange={setSelectedCode}
          isClearable
        />
        <Select
          placeholder="Filter by COA"
          options={allData?.budget?.map(b => ({ value: b.coa, label: b.coa }))}
          value={selectedCOA}
          onChange={setSelectedCOA}
          isClearable
        />
        <Select
          placeholder="Filter by Bank"
          options={allData?.bank?.map(b => ({ value: b.id, label: b.name }))}
          value={selectedBank}
          onChange={setSelectedBank}
          isClearable
        />
        <Select
          placeholder="Filter by Program"
          options={allData?.program?.map(p => ({ value: p.programCode, label: p.name }))}
          value={selectedProgram}
          onChange={setSelectedProgram}
          isClearable
        />
        <Select
          placeholder="Filter by Collection Center"
          options={allData?.cc?.map(cc => ({ value: cc.id, label: cc.collection_name }))}
          value={selectedCollectionCenter}
          onChange={setSelectedCollectionCenter}
          isClearable
        />
        <Select
          placeholder="Filter by Payee"
          options={allData?.suppliers?.map(s => ({ value: s.id, label: s.name }))}
          value={selectedPayee}
          onChange={setSelectedPayee}
          isClearable
        />
        <input
          type="text"
          placeholder="Search Description"
          value={descriptionSearch}
          onChange={e => setDescriptionSearch(e.target.value)}
          className="border rounded px-2 py-1"
        />
        {/* <Select
          placeholder="Filter by Department"
          options={allData?.department?.map(d => ({ value: d.id, label: d.name }))}
          value={selectedDepartment}
          onChange={setSelectedDepartment}
          isClearable
        /> */}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-md">
          <thead>
            <tr className="bg-gray-200 text-left">
              <th className="px-4 py-2">Code</th>
              <th className="px-4 py-2">Code Name</th>
              <th className="px-4 py-2">COA</th>
              <th className="px-4 py-2">COA Name</th>
              <th className="px-4 py-2">Program</th>
              <th className="px-4 py-2">Subprogram</th>
              <th className="px-4 py-2">Description</th>
              <th className="px-4 py-2">Payee</th>
              <th className="px-4 py-2">Collection Center</th>
              <th className="px-4 py-2">Cheque</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Source Of Fund</th>
              <th className="px-4 py-2">PV</th>
              <th className="px-4 py-2">Bank</th>
              <th className="px-4 py-2">Debit</th>
              <th className="px-4 py-2">Credit</th>
            </tr>
          </thead>
          <tbody>
            {groupedRows.length > 0 ? groupedRows : (
              <tr>
                <td colSpan="14" className="text-center py-4">
                  <div className="flex flex-col justify-center items-center">
                    <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                    <p className="text-gray-600">No data available</p>
                  </div>
                </td>
              </tr>
            )}
            {/* Final total row */}
            {groupedRows.length > 0 && (
              <tr className="bg-blue-100 font-bold">
                <td colSpan={14}>Total</td>
                <td>{formatToZMW(sortedData.reduce((sum, item) => sum + (item.type === 'income' ? Number(item.amount) : 0), 0))}</td>
                <td>{formatToZMW(sortedData.reduce((sum, item) => sum + (item.type === 'expense' ? Number(item.amount) : 0), 0))}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
